import { useModalViewContext } from 'Views/Onboarding/Contexts/ModalViewContext';

const getName = (resource) => {
  return `BalanceSheetLineItem-${resource.type()}-${resource.id()}`;
};

export default function useLineItem(resource) {
  const {
    isModalOpen,
    handleShowModal,
    handleHideModal,
  } = useModalViewContext();

  const modalName = getName(resource);

  const handleClickItem = () => {
    handleShowModal(modalName);
  };

  return {
    isModalOpen: isModalOpen(modalName),
    handleCloseModal: handleHideModal,
    handleClickItem,
  };
}
